import { z } from 'zod'

import { EetEnvironment } from '../enums'

// Messages are i18n keys: each app translates them.
export const EetCertificateFormSchema = z.object({
  certificate: z.string().min(1, 'cashRegister.eet.form.certificate.required'),
  password: z.string().min(1, 'cashRegister.eet.form.password.required'),
  environment: z.nativeEnum(EetEnvironment),
})

export const EetSettingsFormSchema = z.object({
  enabled: z.boolean(),
  environment: z.nativeEnum(EetEnvironment),
  verificationMode: z.boolean(),
  workplaceId: z.coerce.number().min(1).max(999999999),
})

export type EetCertificateFormValues = z.infer<typeof EetCertificateFormSchema>
export type EetSettingsFormValues = z.infer<typeof EetSettingsFormSchema>
